import axios, { AxiosPromise } from 'axios';
import { DASHBOARD_API_TOKEN_NAME } from '../constants';
import { history } from '../common/helpers';
import { env } from '../env';

const UNAUTHORIZED = 401;

var retryCount = 0;

const instance = axios.create({
  baseURL: env.REACT_APP_DASHBOARD_API_URL,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: false,
});

instance.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response;
    if (status === UNAUTHORIZED) {
      retryCount = retryCount + 1;
      sessionStorage.removeItem(DASHBOARD_API_TOKEN_NAME);
      if (retryCount > 1) {
        return Promise.reject(error);
      } else {
        history.navigate('/signin');
      }
    }
    return Promise.reject(error);
  }
);

export const commonService = {
  get: function <T = any>(url: string, config?): AxiosPromise<T> {
    const token = sessionStorage.getItem(DASHBOARD_API_TOKEN_NAME);
    if (token) {
      return instance.get<T>(url, {
        ...config,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
    }
    return instance.get<T>(url, config);
  },
  post: function <T = any>(url, data?): AxiosPromise<T> {
    const token = sessionStorage.getItem(DASHBOARD_API_TOKEN_NAME);
    if (token) {
      return instance.post<T>(url, data, {
        headers: { Authorization: 'Bearer ' + token },
      });
    }
    return instance.post<T>(url, data);
  },
  put: function <T = any>(url, data?, config?): AxiosPromise<T> {
    const token = sessionStorage.getItem(DASHBOARD_API_TOKEN_NAME);
    if (token) {
      return instance.put<T>(url, data, {
        ...config,
        headers: { Authorization: 'Bearer ' + token },
      });
    }
    return instance.put<T>(url, data, config);
  },
  patch: function <T = any>(url, data?): AxiosPromise<T> {
    const token = sessionStorage.getItem(DASHBOARD_API_TOKEN_NAME);
    if (token) {
      return instance.patch<T>(url, data, {
        headers: { Authorization: 'Bearer ' + token },
      });
    }
    return instance.patch<T>(url, data);
  },
  del: function <T = any>(url, config?): AxiosPromise<T> {
    const token = sessionStorage.getItem(DASHBOARD_API_TOKEN_NAME);
    if (token) {
      return instance.delete<T>(url, {
        ...config,
        headers: { Authorization: 'Bearer ' + token },
      });
    }
    return instance.delete<T>(url, config);
  },
};
